module.exports = __webpack_public_path__ + "static/img/Out_pt.dfa3619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Out_pt.svg
// module id = I2Xz
// module chunks = 7